angular
    .module('app.components')
    .directive('deviceTypeRatioChart', ['$filter', '$timeout', 'deviceTypeRatioConfig',
        ($filter, $timeout, deviceTypeRatioConfig) => {
            const {DEVICES, OPTIONS} = deviceTypeRatioConfig;
            const KEY_DRILLDOWN = 'deviceTypeRatioChartDrilldown';

            Highcharts.setOptions({
                lang: {
                    drillUpText: 'Back',
                },
            });

            return {
                restrict: "E",
                scope: {
                    data: '=',
                    identifier: '@',
                    interactive: '=',
                },
                template: '<highchart id="{{identifier}}" config="config"></highchart>',
                link: (scope) => {
                  scope.$watch('data', newValue => {
                    if (newValue) {
                      scope.config.refreshData(newValue);
                    }
                  }, true);
                },

                // NOTE: DO NOT move the config options to the link function.
                // See : https://github.com/pablojim/highcharts-ng/issues/384
                controller: ($scope) => {
                    const options = {...OPTIONS};
                    if ($scope.interactive) {
                        // options.plotOptions.pie.point = {
                        //   events: {
                        //     legendItemClick: function () {
                        //       $(`.dtr-legend-${this.name.toLowerCase()}`).toggleClass('is-hidden');
                        //     }
                        //   }
                        // };
                    } else {
                        options.tooltip = {
                            animation: false,
                            enabled: false,
                            shadow: false
                        };
                    }

                    $scope.config = {
                        options,
                        refreshData: function (dataSource) {
                            if (angular.isUndefined(dataSource)) return;

                            const hasDrilldown = (type) => _.values(dataSource.subdeviceCounts[type.toLowerCase()])
                                .reduce((memo, value) => memo + value, 0) > 0;

                            const getData = () => _.keys(DEVICES).reduce((memo, type) => {
                                const key = type.toLowerCase();
                                if (dataSource.deviceCounts[key] > 0) {
                                    return [...memo, {
                                        y: dataSource.deviceCounts[key],
                                        name: type,
                                        color: DEVICES[type].color,
                                        drilldown: (type !== 'Other' && hasDrilldown(type)) ? type : null,
                                        expand: (type === 'Other' || !hasDrilldown(type)) ? 'hidden' : '',
                                    }];
                                }
                                return memo;
                            }, []);

                            const getDeviceTotal = () => getData().reduce((memo, data) => memo + data.y, 0);

                            $scope.totalCount = getDeviceTotal();

                            this.series = [{
                                name: 'DeviceTypes',
                                data: getData(),
                                enableMouseTracking: $scope.interactive,
                                states: {
                                    hover: {
                                        enabled: $scope.interactive
                                    }
                                }
                            }];

                            if ($scope.interactive) {
                                const {chart} = options;
                                const {subdeviceCounts: category} = dataSource;
                                let keyDrilldown = localStorage.getItem(KEY_DRILLDOWN);

                                chart.events = {
                                    load: ({target: {series}}) => {
                                        $timeout(() => {
                                            doDrilldown(series);
                                        }, 100);
                                    },
                                    drilldown: function ({point, point: {name, drilldown}}) {
                                        if (name !== 'Other') {
                                            $(`#${$scope.identifier}`).addClass('dtr-drilldown');
                                            $(`#${$scope.identifier}Category`).append(`, ${drilldown}`);

                                            keyDrilldown = drilldown;
                                            localStorage.setItem(KEY_DRILLDOWN, keyDrilldown);

                                            const getByCategory = cat => (
                                                _.keys(category[cat]).map(key => [key, category[cat][key]]));

                                            const drilldowns = {};
                                            _.keys(DEVICES).forEach(name => drilldowns[name] = {
                                                name,
                                                data: getByCategory(name.toLowerCase()).filter(item => item[1] > 0)
                                            });

                                            $scope.totalCount = drilldowns[name].data.reduce((memo, item) => memo + item[1], 0);

                                            this.addSeriesAsDrilldown(point, {
                                                name,
                                                data: drilldowns[name].data
                                                    .filter(item => (item[1] / $scope.totalCount * 100) >= 0.1)
                                                    .map(item => {
                                                        const sub = DEVICES[name][item[0]];
                                                        return {
                                                            y: item[1],
                                                            name: sub && sub['name'],
                                                            color: sub && sub['color'],
                                                        }
                                                    })
                                            });
                                        }
                                    },
                                    drillup: () => {
                                        $(`#${$scope.identifier}`).removeClass('dtr-drilldown');
                                        $(`#${$scope.identifier}Category`).empty();

                                        keyDrilldown = null;
                                        $scope.totalCount = getDeviceTotal();
                                        localStorage.setItem(KEY_DRILLDOWN, keyDrilldown);
                                    }
                                };

                                const doDrilldown = series => {
                                    const serie = series && series[0] &&
                                        series[0].data.find(item => item.drilldown === keyDrilldown);
                                    if (serie && serie.drilldown && serie.doDrilldown) {
                                        serie.doDrilldown();
                                    }
                                };

                                const chartRef = this.getHighcharts();
                                if (chartRef.series && keyDrilldown) {
                                    chartRef.drillUp();
                                    $timeout(() => {
                                        doDrilldown(chartRef.series);
                                    }, 100);
                                }
                            }
                        }
                    };
                }
            }
        }
    ]);
